/**
 * Round input `value` to number of decimal `places`
 * @param value
 * @param places
 * @returns {number}
 */
export const round = (value: number, places: number) => Math.round(value * 10 ** places) / 10 ** places
